import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import authApi from '_api/auth'
import axiosClient from '_api/axiosClient'

const SUCCESS_CODE = 75300

const ERROR_MESSAGE_MAP = {
  75301: 'Invalid email address',
  75302: 'Name is required',
  75303: 'Invalid phone number',
}

export const useGuestRegistration = () => {
  const { addToast } = useToasts()
  const [loading, setLoading] = useState(false)

  const registerGuestAndGetToken = async (guestFormData, setComment, setUserToken) => {
    if (!guestFormData) {
      addToast('Please fill in your information', { appearance: 'error', autoDismiss: true })
      return null
    }

    const { name, email, mobile, noteToHost } = guestFormData

    if (!name?.trim() || !email?.trim() || !mobile?.trim()) {
      addToast('Please provide valid name, email, and mobile number', { appearance: 'error', autoDismiss: true })
      return null
    }

    try {
      setLoading(true)

      const res = await authApi.createUserPotential({
        email: email.trim(),
        name: name.trim(),
        phone: mobile.trim(),
      })

      if (res?.msgCode === SUCCESS_CODE) {
        const { token } = res.msgResp
        setUserToken(token)
        axiosClient.defaults.headers.common.Authorization = `Bearer ${token}`

        if (noteToHost && setComment) {
          setComment(noteToHost)
        }

        return token
      }

      const errorMessage = res?.msgResp || 'Failed to register guest info'
      addToast(errorMessage, { appearance: 'error', autoDismiss: true })
      return null
    } catch (err) {
      const errorMessage = ERROR_MESSAGE_MAP[err?.msgCode] || err?.msgResp || 'Something went wrong'
      addToast(errorMessage, { appearance: 'error', autoDismiss: true })
      return null
    } finally {
      setLoading(false)
    }
  }

  return { registerGuestAndGetToken, loading }
}
